module.exports = __webpack_public_path__ + "img/logo-square.d8b796c1.svg";